/* eslint-disable */
import { createApp } from 'vue';
import { piniaInstance } from '@core/stores/pinia-instance';
import App from './App.vue';
import router from '@/router';
import Static from '@core/plugins/static';
import settings from 'settings';
import filters from '@core/services/filters'; //IMPORTANT. do not remove. Vue needs to see this before other components. Weird stuff
import api from '@core/services/api/_api';
import LogRocket from 'logrocket';
import mitt from 'mitt';
import Notifications from '@kyvg/vue3-notification';
import util from '@core/services/util';
import moment from 'moment';
moment.locale('en');

import MeetingHub from '@core/plugins/meetingHub';
import MeetingHelper from '@core/plugins/MeetingHelper';

const app = createApp(App);
app.use(piniaInstance);
app.use(router);
app.provide('$router', router);

const eventBus = mitt();
const meetingHub = mitt();

// Global Properties
app.config.globalProperties.EventBus = eventBus;
app.config.globalProperties.MeetingHubBus = meetingHub;
// app.config.globalProperties.DealRoomBus = dealRoomHub;
app.config.globalProperties.$filters = filters;
// app.config.productionTip = false;
app.use(Static);

app.use(MeetingHub).use(MeetingHelper);
app.use(Notifications);

import { useUserStore } from '@core/stores/UserStore';
router.isReady().then(async () => {
	const route = router.currentRoute.value;

	if (route.meta.requiresCustomerData) {
		const userStore = useUserStore();

		const queryId = route.query.id as string;
		if (queryId) {
			const decryptedId = util.decryptJSONText(queryId);
			const customerId = JSON.parse(decryptedId);

			if (customerId) {
				await userStore.initializeCustomerData(customerId);
			}
		}
	}
});

app.provide('EventBus', eventBus);
app.provide('MeetingHubBus', meetingHub);
app.provide('$filters', filters);

const customerAppSettings = await api.settings.getCustomerAppSettings();
if (customerAppSettings.data) {
	await api
		.getCountryDetails()
		.then((response: any) => {
			settings.countries = response.data;
		})
		.catch((err: any) => {
			console.log('error', err);
		});

	Object.assign(settings, customerAppSettings.data);

	//INIT LOG ROCKET
	// only record when the application is done INSTORE on the prefilled data page off the bat.
	// if the lead source = web, dont record here.
	const shouldRecordSession = () => {
		const subdomain = window.location.href.split(settings.logRocketRootHostName)[1]; // Extracts the subdomain
		if (!subdomain) return true;

		const excludedSubdomains = settings.logRocketExclusionsList; // Subdomains to exclude

		// Returns true if the current exludedSubDomains is not included in the subdomain
		return !excludedSubdomains.some((sb: string) => subdomain.includes(sb));
	};

	if (shouldRecordSession()) {
		LogRocket.init(settings.logRocketOrg);
		//LogRocket.init(settings.logRocketOrg, { rootHostname: settings.logRocketRootHostName });
	}
}

app.mount('#customerApp');
console.log('This is customer app', app);
